<template>
    <div class="common_container">
        <el-form ref="form" :model="form" label-width="80px" class="event-form" >
            <el-row>
                <el-col :span="12">
                    <el-form-item label="班次" prop="schedulingId">
                        <el-select v-model="form.schedulingId" placeholder="请选择" class="form-input">
                            <el-option v-for="item in typeList" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14">
                    <el-form-item label="值班人员">
                        <div>
                            <el-input type="text" placeholder="" disabled v-model="form.dutyStaffName" class="form-input mr10"></el-input>
                            <router-link :to="{ path:'/requesterList',query: { enable:true, moreSelect:isMoreSelect,tit:'选择人员',callback:getList } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="开始时间" prop="startDate">
                        <el-date-picker class="form-date-input"
                            v-model="form.startDate"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12" ></el-col>
            </el-row>
            <el-row v-if="type == 'add'">
                <el-col :span="12">
                    <el-form-item label="结束时间" prop="endDate">
                        <el-date-picker class="form-date-input"
                            v-model="form.endDate"
                            type="date"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12" ></el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="submit" :disabled="isSubmit">提交</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

    import services from './workforce.service.js';

    export default {
        props:{
            type:{
                type:String,
                default:"add"
            },
            message:Number,
            callback:Function
        },
        data() {
            return {

                form:{

                    schedulingId:'',
                    dutyStaffUserIds:'',
                    dutyStaffName:'',
                    endDate:'',
                    startDate:'',
                },
                typeList:[],//工作类型
                hasTwoTime:true,//是否可以选择班次时间段2
                isSubmit:false,
                isMoreSelect:true,//是否允许选择多个人  新增 true  编辑 false
            }
        },
        mounted(){
            this.getSchedulingIdList();
            if(this.type == 'edit'){
                this.isMoreSelect = false;
                this.$modal.title = "修改信息";
                this.getDetail();
            }
        },
        methods:{
            getSchedulingIdList(){//获取班次列表
                services.schedulingList({pageIndex:1,pageSize:10,keyword:''}).then(res=>{
                    res.list.forEach(item=>{
                        this.typeList.push({id:item.id,cname:item.title})
                    })
                })
            },
            getList(data){//获取选中的人员信息
                this.form.dutyStaffUserIds = '';
                this.form.dutyStaffName = '';
                let userIdArray = [];
                let nameArray = [];
                if(this.type == 'add'){
                    data.forEach((item,index)=>{
                        userIdArray.push(item.userid);
                        nameArray.push(item.name);
                    })
                    this.form.dutyStaffUserIds = userIdArray.toString();
                    this.form.dutyStaffName = nameArray.toString();
                }else{
                    this.form.dutyStaffUserIds = data.userid;
                    this.form.dutyStaffName = data.name;
                }
            },
            getDetail(){//获取排班详情
                services.detailArrangement({id:this.message}).then(res => {
                    // this.form = res;
                    this.form.schedulingId = res.schedulingId
                    this.form.dutyStaffUserIds = res.dutyStaffUserid;
                    this.form.dutyStaffName = res.dutyStaffName;
                    this.form.startDate = res.dutyDate;
                    this.form.endDate = res.dutyDate;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            getData(data){//转换日期格式
                let date = new Date(data);
                let year = date.getFullYear();
                let month = (date.getMonth()+1) > 9 ? date.getMonth()+1 : '0'+(date.getMonth()+1);
                let day = date.getDate() > 9 ? date.getDate() : '0'+date.getDate();
                return year + '-' + month + '-' + day;
            },
            submit(){//提交信息
                let sendData = {};
                this.isSubmit=true
                if (!this.form.startDate||!this.form.endDate||!this.form.dutyStaffName) {
                    this.isSubmit=false
                    this.$message.error('有未填写的信息，请填写完全')
                }else{
                    if(this.type == 'edit'){
                        sendData.id = this.message;
                        sendData.schedulingId=this.form.schedulingId;
                        // sendData.endDate=this.getData(this.form.endDate);
                        sendData.startDate=this.getData(this.form.startDate);
                        sendData.dutyStaffUserId=this.form.dutyStaffUserIds;
                        sendData.dutyStaffName=this.form.dutyStaffName;
                    }else{
                        sendData.schedulingId=this.form.schedulingId;
                        sendData.dutyStaffUserIds=this.form.dutyStaffUserIds.split(',');
                        sendData.dutyStaffName=this.form.dutyStaffName.split(',');
                        sendData.endDate=this.getData(this.form.endDate);
                        sendData.startDate=this.getData(this.form.startDate);
                    }
                    // let sendData = {
                    //     schedulingId:this.form.schedulingId,
                    //     dutyStaffUserIds:this.form.dutyStaffUserIds,
                    //     dutyStaffName:this.form.dutyStaffName,
                    //     endDate:this.getData(this.form.endDate),
                    //     startDate:this.getData(this.form.startDate),
                    // }
                    if(this.type == 'edit'){
                        // sendData.id = this.message;
                        services.updateArrangement(sendData).then(res => {
                            this.$message.success("成功修改排班信息");
                            this.close(true);
                        }).catch(err => {
                            this.isSubmit=false
                            this.$message.error(err.message);
                        })
                    }else{
                        services.addArrangement(sendData).then(res => {
                            this.$message.success("成功添加排班");
                            this.close(true);
                        }).catch(err => {
                            this.isSubmit=false
                            this.$message.error(err.message);
                        })
                    }
                }


            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
